var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonVector(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 771,
    height: 210,
    viewBox: "0 0 771 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M396.088 108.807L611.356 201.505C630.161 209.603 651.13 211.197 670.942 206.034L748.333 185.866C771.391 179.858 791.217 165.138 803.64 144.805L811.485 131.966C848.94 70.6608 804.819 -8 732.978 -8H12.3366C5.52332 -8 0 -2.47671 0 4.33662C0 10.6389 4.75018 15.9278 11.0162 16.6024L265.341 43.9802C277.695 45.3101 289.651 49.1284 300.488 55.2048L396.088 108.807Z",
    fill: "url(#paint0_linear_875_4267)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_875_4267",
    x1: 448.5,
    y1: -8,
    x2: 448.5,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F7F1",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonVector);
export default __webpack_public_path__ + "static/media/personVector.5b7c7a8c97458bbb145a3907967c9c6d.svg";
export { ForwardRef as ReactComponent };